export const MFA_ENABLED_KEY = 'mfaEnabled';
export const MFA_NUDGE_STATUS_KEY = 'mfaNudgeStatus';
export const MAX_MFA_NUDGE_DISMISSALS = 3;
export const MAX_PHONE_NUMBER_LENGTH = 15;
